import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'

import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_745dc36d from 'nuxt_plugin_plugin_745dc36d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_735c821c from 'nuxt_plugin_recaptcha_735c821c' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_b279b8aa from 'nuxt_plugin_cookieuniversalnuxt_b279b8aa' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_625dea5f from 'nuxt_plugin_workbox_625dea5f' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_09926272 from 'nuxt_plugin_metaplugin_09926272' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_0e3a07e6 from 'nuxt_plugin_iconplugin_0e3a07e6' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_pluginserver_31f3e14e from 'nuxt_plugin_pluginserver_31f3e14e' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_fd66c45e from 'nuxt_plugin_pluginclient_fd66c45e' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_axios_ce402bfa from 'nuxt_plugin_axios_ce402bfa' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_apollomodule_9f33fa62 from 'nuxt_plugin_apollomodule_9f33fa62' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_pluginutils_3b2d6a98 from 'nuxt_plugin_pluginutils_3b2d6a98' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_49049c3a from 'nuxt_plugin_pluginrouting_49049c3a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_007c3c6c from 'nuxt_plugin_pluginmain_007c3c6c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_image_f8323204 from 'nuxt_plugin_image_f8323204' // Source: ./image.js (mode: 'all')
import nuxt_plugin_deviceplugin_ae8a62e4 from 'nuxt_plugin_deviceplugin_ae8a62e4' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_anime_789b8b0e from 'nuxt_plugin_anime_789b8b0e' // Source: ../../../plugins/anime.js (mode: 'client')
import nuxt_plugin_elementui_72a9ed1c from 'nuxt_plugin_elementui_72a9ed1c' // Source: ../../../plugins/element-ui.js (mode: 'all')
import nuxt_plugin_lenisclient_479696e7 from 'nuxt_plugin_lenisclient_479696e7' // Source: ../../../plugins/lenis.client.js (mode: 'client')
import nuxt_plugin_swiperclient_d2033868 from 'nuxt_plugin_swiperclient_d2033868' // Source: ../../../plugins/swiper.client.js (mode: 'client')
import nuxt_plugin_previewclient_5fee6a20 from 'nuxt_plugin_previewclient_5fee6a20' // Source: ../../../plugins/preview.client.js (mode: 'client')
import nuxt_plugin_previewredirects_0e8514db from 'nuxt_plugin_previewredirects_0e8514db' // Source: ../../../plugins/preview-redirects.js (mode: 'all')
import nuxt_plugin_dateUtils_2e297fea from 'nuxt_plugin_dateUtils_2e297fea' // Source: ../../../plugins/dateUtils.js (mode: 'all')
import nuxt_plugin_imagesLoaded_0c427e04 from 'nuxt_plugin_imagesLoaded_0c427e04' // Source: ../../../plugins/imagesLoaded.js (mode: 'all')
import nuxt_plugin_blurhash_02785aa8 from 'nuxt_plugin_blurhash_02785aa8' // Source: ../../../plugins/blurhash.js (mode: 'all')
import nuxt_plugin_localePathWithTrailingSlash_2faec49e from 'nuxt_plugin_localePathWithTrailingSlash_2faec49e' // Source: ../../../plugins/localePathWithTrailingSlash.js (mode: 'all')
import nuxt_plugin_i18nTrailingSlashMixin_7e549cfa from 'nuxt_plugin_i18nTrailingSlashMixin_7e549cfa' // Source: ../../../plugins/i18nTrailingSlashMixin.js (mode: 'all')
import nuxt_plugin_fuse_6e95fa80 from 'nuxt_plugin_fuse_6e95fa80' // Source: ../../../plugins/fuse.js (mode: 'client')
import nuxt_plugin_eventbus_2faefc80 from 'nuxt_plugin_eventbus_2faefc80' // Source: ../../../plugins/event-bus.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_745dc36d === 'function') {
    await nuxt_plugin_plugin_745dc36d(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_735c821c === 'function') {
    await nuxt_plugin_recaptcha_735c821c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_b279b8aa === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_b279b8aa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_625dea5f === 'function') {
    await nuxt_plugin_workbox_625dea5f(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_09926272 === 'function') {
    await nuxt_plugin_metaplugin_09926272(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_0e3a07e6 === 'function') {
    await nuxt_plugin_iconplugin_0e3a07e6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_31f3e14e === 'function') {
    await nuxt_plugin_pluginserver_31f3e14e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_fd66c45e === 'function') {
    await nuxt_plugin_pluginclient_fd66c45e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ce402bfa === 'function') {
    await nuxt_plugin_axios_ce402bfa(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_9f33fa62 === 'function') {
    await nuxt_plugin_apollomodule_9f33fa62(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3b2d6a98 === 'function') {
    await nuxt_plugin_pluginutils_3b2d6a98(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_49049c3a === 'function') {
    await nuxt_plugin_pluginrouting_49049c3a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_007c3c6c === 'function') {
    await nuxt_plugin_pluginmain_007c3c6c(app.context, inject)
  }

  if (typeof nuxt_plugin_image_f8323204 === 'function') {
    await nuxt_plugin_image_f8323204(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_ae8a62e4 === 'function') {
    await nuxt_plugin_deviceplugin_ae8a62e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_anime_789b8b0e === 'function') {
    await nuxt_plugin_anime_789b8b0e(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_72a9ed1c === 'function') {
    await nuxt_plugin_elementui_72a9ed1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lenisclient_479696e7 === 'function') {
    await nuxt_plugin_lenisclient_479696e7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiperclient_d2033868 === 'function') {
    await nuxt_plugin_swiperclient_d2033868(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_previewclient_5fee6a20 === 'function') {
    await nuxt_plugin_previewclient_5fee6a20(app.context, inject)
  }

  if (typeof nuxt_plugin_previewredirects_0e8514db === 'function') {
    await nuxt_plugin_previewredirects_0e8514db(app.context, inject)
  }

  if (typeof nuxt_plugin_dateUtils_2e297fea === 'function') {
    await nuxt_plugin_dateUtils_2e297fea(app.context, inject)
  }

  if (typeof nuxt_plugin_imagesLoaded_0c427e04 === 'function') {
    await nuxt_plugin_imagesLoaded_0c427e04(app.context, inject)
  }

  if (typeof nuxt_plugin_blurhash_02785aa8 === 'function') {
    await nuxt_plugin_blurhash_02785aa8(app.context, inject)
  }

  if (typeof nuxt_plugin_localePathWithTrailingSlash_2faec49e === 'function') {
    await nuxt_plugin_localePathWithTrailingSlash_2faec49e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18nTrailingSlashMixin_7e549cfa === 'function') {
    await nuxt_plugin_i18nTrailingSlashMixin_7e549cfa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fuse_6e95fa80 === 'function') {
    await nuxt_plugin_fuse_6e95fa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventbus_2faefc80 === 'function') {
    await nuxt_plugin_eventbus_2faefc80(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
